// eslint-disable
import React, { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../database/config';
import './Footer.css';

// Social Media Icon Components
const InstagramIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-instagram" viewBox="0 0 16 16">
  <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334"/>
</svg>
);

const LinkedInIcon = () => (
  <svg fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

const XTwitterIcon = () => (
  <svg fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);

const WhatsAppIcon = () => (
  <svg fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

const PinterestIcon = () => (
  <svg fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.174-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.097.118.112.322.085.495-.09.405-.293 1.199-.332 1.363-.053.225-.172.271-.402.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.357-.629-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24.009 12.017 24c6.624 0 11.99-5.367 11.99-11.987C24.007 5.367 18.641.001 12.017.001z" />
  </svg>
);

const MailIcon = () => (
  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
  </svg>
);

const WhatsappIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16">
  <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
</svg>
);

const ChevronDownIcon = () => (
  <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
  </svg>
);

// App Store Badge SVG Components
const AppStoreBadge = ({ className }) => (
  <svg className={className} width="135" height="40" viewBox="0 0 135 40" xmlns="http://www.w3.org/2000/svg">
    <rect width="135" height="40" rx="5" fill="black" />
    <rect x="0.5" y="0.5" width="134" height="39" rx="4.5" stroke="#A6A6A6" />
    <path d="M30.128 19.784c-.029-3.223 2.639-4.791 2.761-4.864-1.511-2.203-3.853-2.504-4.676-2.528-1.967-.207-3.875 1.177-4.877 1.177-1.022 0-2.565-1.157-4.228-1.123-2.14.033-4.142 1.272-5.24 3.196-2.266 3.923-.576 9.688 1.595 12.859 1.086 1.553 2.355 3.287 4.016 3.226 1.625-.067 2.232-1.036 4.193-1.036 1.943 0 2.513 1.036 4.207.997 1.744-.028 2.842-1.56 3.89-3.127 1.255-1.78 1.759-3.533 1.779-3.623-.041-.014-3.387-1.291-3.42-5.154z" fill="white" />
    <path d="M26.928 10.306c.874-1.093 1.472-2.58 1.306-4.089-1.265.056-2.847.875-3.758 1.944-.806.942-1.526 2.486-1.34 3.938 1.421.106 2.88-.717 3.792-1.793z" fill="white" />
    <path d="M53.645 31.504h-2.271l-1.244-3.909h-4.324l-1.185 3.909h-2.211l4.284-13.308h2.646l4.305 13.308zm-3.89-5.549l-1.125-3.475c-.119-.355-.342-1.191-.671-2.507h-.04c-.131.566-.342 1.402-.632 2.507l-1.105 3.475h3.573z" fill="white" />
    <path d="M64.662 26.588c0 1.632-.441 2.922-1.323 3.869-.79.846-1.772 1.269-2.947 1.269-1.264 0-2.172-.454-2.725-1.362h-.04v5.055h-2.132V25.067c0-1.026-.027-2.079-.079-3.159h1.875l.119 1.521h.04c.711-1.146 1.79-1.718 3.238-1.718 1.136 0 2.083.447 2.842 1.342.761.895 1.132 2.074 1.132 3.535zm-2.172.078c0-.934-.212-1.704-.638-2.31-.454-.632-1.063-.949-1.828-.949-.517 0-.986.172-1.404.513-.419.343-.692.788-.82 1.338-.066.263-.099.479-.099.65v1.6c0 .698.216 1.287.649 1.768.432.48.996.721 1.693.721.792 0 1.409-.311 1.848-.932.44-.621.599-1.432.599-2.399z" fill="white" />
    <path d="M75.699 26.588c0 1.632-.441 2.922-1.324 3.869-.789.846-1.772 1.269-2.946 1.269-1.264 0-2.172-.454-2.724-1.362h-.04v5.055h-2.133V25.067c0-1.026-.027-2.079-.079-3.159h1.875l.119 1.521h.04c.71-1.146 1.789-1.718 3.238-1.718 1.135 0 2.082.447 2.841 1.342.762.895 1.133 2.074 1.133 3.535zm-2.172.078c0-.934-.213-1.704-.639-2.31-.454-.632-1.062-.949-1.828-.949-.518 0-.986.172-1.404.513-.42.343-.693.788-.82 1.338-.065.263-.099.479-.099.65v1.6c0 .698.216 1.287.649 1.768.433.48.997.721 1.694.721.792 0 1.408-.311 1.847-.932.44-.621.6-1.432.6-2.399z" fill="white" />
    <path d="M87.873 27.752c0 1.132-.393 2.053-1.182 2.764-.867.776-2.074 1.165-3.625 1.165-1.432 0-2.58-.276-3.446-.829l.494-1.777c.934.566 1.958.849 3.07.849.792 0 1.409-.179 1.848-.537.439-.358.659-.837.659-1.437 0-.539-.185-.992-.553-1.362-.369-.369-.98-.711-1.828-1.028-2.32-.855-3.48-2.105-3.48-3.751 0-1.093.405-1.988 1.215-2.685.808-.696 1.886-1.044 3.232-1.044 1.199 0 2.195.209 2.988.628l-.533 1.738c-.739-.408-1.574-.612-2.507-.612-.739 0-1.316.181-1.729.546-.352.328-.527.728-.527 1.201 0 .526.202.959.605 1.299.352.315 1 .657 1.947.987 1.145.447 1.994.97 2.546 1.571.551.603.826 1.357.826 2.304z" fill="white" />
    <path d="M94.739 23.202h-2.349v4.833c0 1.228.43 1.842 1.293 1.842.396 0 .725-.034.986-.104l.059 1.619c-.434.158-1.006.237-1.718.237-.873 0-1.553-.266-2.043-.799-.489-.532-.734-1.426-.734-2.681v-4.947h-1.4v-1.6h1.4v-1.757l2.093-.631v2.388h2.349v1.6h.064z" fill="white" />
    <path d="M105.182 26.627c0 1.475-.422 2.686-1.264 3.633-.882.974-2.052 1.461-3.516 1.461-1.412 0-2.531-.468-3.357-1.402-.828-.934-1.241-2.112-1.241-3.534 0-1.487.428-2.705 1.283-3.652.856-.948 2.012-1.422 3.476-1.422 1.412 0 2.542.467 3.396 1.402.812.908 1.223 2.079 1.223 3.514zm-2.211.066c0-.885-.19-1.644-.572-2.277-.447-.763-1.086-1.145-1.916-1.145-.857 0-1.508.382-1.955 1.145-.382.634-.572 1.405-.572 2.317 0 .885.19 1.644.572 2.276.46.763 1.105 1.145 1.936 1.145.816 0 1.455-.39 1.916-1.165.392-.645.591-1.412.591-2.296z" fill="white" />
    <path d="M112.016 23.406c-.211-.039-.435-.059-.672-.059-.738 0-1.309.279-1.711.837-.354.499-.532 1.127-.532 1.884v5.436h-2.132l.02-7.103c0-1.197-.026-2.287-.079-3.268h1.856l.079 1.984h.059c.225-.684.576-1.233 1.056-1.648.467-.368.974-.553 1.521-.553.197 0 .373.015.535.039v2.451z" fill="white" />
    <path d="M121.339 26.252c0 .381-.025.702-.079.962h-6.396c.026.942.332 1.664.918 2.166.532.447 1.216.671 2.054.671.929 0 1.778-.148 2.546-.444l.326 1.481c-.9.394-1.963.592-3.189.592-1.476 0-2.632-.434-3.473-1.302-.84-.868-1.26-2.033-1.26-3.494 0-1.435.393-2.632 1.18-3.593.826-1.026 1.942-1.54 3.349-1.54 1.381 0 2.426.513 3.139 1.54.563.816.885 1.826.885 3.001zm-2.034-.553c.014-.628-.123-1.171-.412-1.629-.369-.592-.936-.888-1.699-.888-.7 0-1.267.289-1.699.867-.354.461-.563 1.014-.632 1.66l4.442-.01z" fill="white" />
    <path d="M49.05 10.009c0 1.177-.353 2.063-1.058 2.658-.658.553-1.593.829-2.803.829-.601 0-1.116-.025-1.544-.078V7.27c.559-.092 1.161-.138 1.812-.138 1.145 0 2.008.252 2.59.755.651.566.977 1.371.977 2.122zm-1.1.029c0-.578-.169-1.031-.508-1.36-.339-.329-.838-.494-1.497-.494-.28 0-.52.019-.718.058v3.822c.111.02.322.029.632.029.679 0 1.204-.178 1.573-.534.37-.356.518-.858.518-1.521z" fill="white" />
    <path d="M54.909 11.037c0 .697-.199 1.269-.598 1.716-.417.46-.969.69-1.661.69-.666 0-1.196-.221-1.586-.663-.391-.441-.587-1-.587-1.675 0-.703.202-1.28.606-1.73.404-.448.959-.673 1.665-.673.666 0 1.201.22 1.604.66.38.428.557.983.557 1.675zm-1.044.031c0-.418-.09-.777-.27-1.075-.211-.361-.513-.541-.905-.541-.404 0-.712.18-.923.541-.181.299-.271.663-.271 1.094 0 .418.09.776.271 1.075.217.361.521.541.914.541.385 0 .687-.184.904-.551.186-.308.28-.67.28-1.084z" fill="white" />
    <path d="M62.765 8.719l-1.415 4.528h-.945l-.587-1.961c-.145-.48-.265-.957-.358-1.429h-.02c-.086.487-.206.963-.358 1.429l-.617 1.961h-.954l-1.327-4.528h1.043l.509 2.117c.119.491.217.961.294 1.409h.019c.073-.369.193-.836.358-1.399l.637-2.127h.836l.607 2.088c.145.498.264.976.358 1.438h.029c.066-.449.164-.925.294-1.438l.548-2.088h1.049z" fill="white" />
    <path d="M68.197 13.247h-1.008v-2.593c0-.8-.303-1.199-.91-1.199-.298 0-.539.11-.724.33-.185.22-.278.476-.278.77v2.692h-1.008v-3.234c0-.399-.013-.831-.039-1.294h.886l.049.707h.029c.112-.221.28-.404.504-.551.269-.174.568-.261.897-.261.416 0 .762.134 1.038.404.343.33.564.823.564 1.489v2.74z" fill="white" />
    <path d="M71.348 13.247h-1.008V6.831h1.008v6.416z" fill="white" />
    <path d="M77.559 11.037c0 .697-.2 1.269-.598 1.716-.418.46-.97.69-1.661.69-.667 0-1.196-.221-1.587-.663-.391-.441-.587-1-.587-1.675 0-.703.202-1.28.606-1.73.404-.448.96-.673 1.665-.673.666 0 1.201.22 1.605.66.379.428.557.983.557 1.675zm-1.044.031c0-.418-.09-.777-.27-1.075-.211-.361-.513-.541-.905-.541-.405 0-.712.18-.924.541-.181.299-.27.663-.27 1.094 0 .418.089.776.27 1.075.217.361.521.541.914.541.385 0 .687-.184.905-.551.186-.308.28-.67.28-1.084z" fill="white" />
    <path d="M82.693 13.247h-.905l-.078-.541h-.029c-.31.433-.755.65-1.337.65-.434 0-.783-.14-1.048-.42-.241-.255-.362-.576-.362-.961 0-.576.24-1.015.721-1.318.481-.303 1.156-.451 2.024-.445v-.088c0-.618-.325-.927-.974-.927-.463 0-.871.116-1.225.347l-.214-.716c.436-.27.976-.404 1.618-.404 1.233 0 1.849.651 1.849 1.952v1.727c0 .469.023.842.069 1.123l-.109.021zm-.995-1.512v-.727c-1.146-.02-1.718.298-1.718.954 0 .248.067.435.199.559.132.124.301.186.505.186.229 0 .441-.072.638-.214.197-.143.319-.328.366-.561.007-.048.01-.106.01-.197z" fill="white" />
    <path d="M88.682 13.247h-.896l-.049-.738h-.029c-.284.56-.765.846-1.444.846-.549 0-1.006-.215-1.372-.643-.365-.428-.548-.988-.548-1.68 0-.738.199-1.339.598-1.803.385-.433.86-.65 1.425-.65.604 0 1.024.186 1.259.561h.019V6.831h1.008v5.208c0 .439.01.843.029 1.208zm-1.037-1.847v-.787c0-.134-.01-.242-.029-.324-.058-.248-.181-.458-.367-.629-.187-.171-.413-.257-.676-.257-.367 0-.657.153-.867.457-.211.305-.316.695-.316 1.171 0 .458.1.831.301 1.119.212.308.497.461.855.461.322 0 .579-.127.769-.38.184-.24.289-.53.33-.831z" fill="white" />
    <path d="M97.248 11.037c0 .697-.2 1.269-.599 1.716-.417.46-.969.69-1.66.69-.667 0-1.196-.221-1.587-.663-.391-.441-.587-1-.587-1.675 0-.703.202-1.28.606-1.73.404-.448.959-.673 1.665-.673.666 0 1.201.22 1.605.66.379.428.557.983.557 1.675zm-1.044.031c0-.418-.09-.777-.27-1.075-.211-.361-.513-.541-.905-.541-.405 0-.713.18-.924.541-.181.299-.27.663-.27 1.094 0 .418.089.776.27 1.075.217.361.521.541.914.541.385 0 .687-.184.905-.551.187-.308.28-.67.28-1.084z" fill="white" />
    <path d="M102.975 13.247h-1.008v-2.593c0-.8-.303-1.199-.91-1.199-.298 0-.539.11-.724.33-.185.22-.278.476-.278.77v2.692h-1.008v-3.234c0-.399-.013-.831-.039-1.294h.886l.049.707h.029c.112-.221.28-.404.504-.551.269-.174.568-.261.897-.261.416 0 .762.134 1.038.404.343.33.564.823.564 1.489v2.74z" fill="white" />
    <path d="M109.384 9.483h-1.11v2.284c0 .581.203.871.611.871.188 0 .343-.016.467-.049l.028.766c-.206.078-.476.117-.813.117-.413 0-.736-.126-.968-.378-.231-.252-.347-.675-.347-1.268V9.483h-.662v-.764h.662v-.831l.99-.298v1.129h1.11v.764h.032z" fill="white" />
    <path d="M115.006 13.247h-1.007v-2.574c0-.807-.303-1.21-.91-1.21-.465 0-.784.236-.956.707-.032.104-.049.232-.049.384v2.692h-1.008V6.831h1.008v2.648h.019c.316-.494.768-.741 1.357-.741.41 0 .751.134 1.021.403.337.337.525.839.525 1.509v2.597z" fill="white" />
    <path d="M120.727 10.865c0 .18-.013.331-.038.453h-3.023c.014.445.158.786.434 1.024.252.212.576.317.971.317.44 0 .841-.07 1.204-.21l.155.699c-.425.186-.928.28-1.508.28-.698 0-1.246-.205-1.643-.616-.398-.41-.596-.961-.596-1.651 0-.679.186-1.244.559-1.699.39-.485.918-.727 1.584-.727.652 0 1.147.243 1.485.727.269.386.416.863.416 1.403zm-.962-.261c.006-.297-.058-.554-.195-.77-.175-.28-.443-.42-.804-.42-.331 0-.599.137-.804.41-.168.219-.268.479-.299.787l2.102-.007z" fill="white" />
  </svg>
);

const GooglePlayBadge = ({ className }) => (
  <svg className={className} width="135" height="40" viewBox="0 0 135 40" xmlns="http://www.w3.org/2000/svg">
    <rect width="135" height="40" rx="5" fill="black" />
    <rect x="0.5" y="0.5" width="134" height="39" rx="4.5" stroke="#A6A6A6" />
    <path d="M68.135 21.75c-2.392 0-4.346 1.819-4.346 4.328 0 2.491 1.954 4.328 4.346 4.328 2.393 0 4.347-1.837 4.347-4.328 0-2.509-1.954-4.328-4.347-4.328zm0 6.949c-1.312 0-2.442-1.083-2.442-2.621 0-1.557 1.13-2.621 2.442-2.621 1.311 0 2.441 1.064 2.441 2.621 0 1.538-1.13 2.621-2.441 2.621zm-9.478-6.949c-2.392 0-4.346 1.819-4.346 4.328 0 2.491 1.954 4.328 4.346 4.328 2.392 0 4.346-1.837 4.346-4.328 0-2.509-1.954-4.328-4.346-4.328zm0 6.949c-1.312 0-2.442-1.083-2.442-2.621 0-1.557 1.13-2.621 2.442-2.621 1.311 0 2.441 1.064 2.441 2.621 0 1.538-1.13 2.621-2.441 2.621zm-11.281-5.621v1.828h4.382c-.13 1.026-.473 1.778-.994 2.306-.637.637-1.631 1.33-3.388 1.33-2.701 0-4.811-2.178-4.811-4.879 0-2.7 2.11-4.878 4.811-4.878 1.456 0 2.523.573 3.307 1.311l1.293-1.293c-1.093-1.044-2.548-1.847-4.6-1.847-3.7 0-6.81 3.013-6.81 6.707 0 3.695 3.11 6.708 6.81 6.708 1.998 0 3.505-.658 4.683-1.882 1.211-1.211 1.589-2.916 1.589-4.291 0-.426-.034-.82-.103-1.148l-6.169.028zm46.128 1.42c-.361-.969-1.46-2.749-3.702-2.749-2.226 0-4.073 1.751-4.073 4.328 0 2.425 1.829 4.328 4.285 4.328 1.98 0 3.127-1.212 3.601-1.915l-1.474-.984c-.491.721-1.163 1.197-2.127 1.197-.965 0-1.648-.441-2.089-1.308l5.768-2.386-.189-.511zm-5.881 1.436c-.052-1.666 1.292-2.517 2.255-2.517.753 0 1.39.376 1.602.916l-3.857 1.601zm-4.71 4.19h1.905V17.636h-1.905v12.488zm-3.127-7.295h-.068c-.423-.506-1.232-.964-2.258-.964-2.143 0-4.109 1.886-4.109 4.31 0 2.405 1.966 4.291 4.109 4.291 1.026 0 1.835-.458 2.258-.982h.068v.619c0 1.65-.88 2.532-2.302 2.532-1.161 0-1.879-.834-2.177-1.538l-1.66.691c.481 1.163 1.758 2.59 3.849 2.59 2.234 0 4.126-1.317 4.126-4.526V21.95h-1.814l-.022.828zm-2.178 5.966c-1.312 0-2.41-1.102-2.41-2.606 0-1.52 1.098-2.636 2.41-2.636 1.294 0 2.302 1.116 2.302 2.636 0 1.504-1.008 2.606-2.302 2.606zm24.693-11.239h-4.561v12.488h1.902v-4.732h2.659c2.111 0 4.187-1.528 4.187-3.878 0-2.35-2.084-3.878-4.187-3.878zm.05 6.015h-2.709v-4.276h2.709c1.422 0 2.23 1.178 2.23 2.138 0 .943-.808 2.138-2.23 2.138zm11.772-1.792c-1.379 0-2.808.608-3.4 1.951l1.689.706c.362-.706 1.034-.934 1.742-.934.987 0 1.989.593 2.007 1.644v.133c-.344-.199-1.084-.495-1.988-.495-1.822 0-3.678.999-3.678 2.866 0 1.706 1.494 2.804 3.167 2.804 1.283 0 1.989-.574 2.432-1.247h.067v.984h1.839v-4.883c0-2.262-1.69-3.529-3.877-3.529zm-.232 6.983c-.624 0-1.494-.312-1.494-1.082 0-.984 1.083-1.36 2.018-1.36.838 0 1.231.181 1.738.425-.149 1.185-1.165 2.017-2.262 2.017zm10.828-6.706l-2.183 5.535h-.067l-2.265-5.535h-2.051l3.401 7.74-1.94 4.309h1.988l5.24-12.049h-2.123zm-17.27 8.186h1.905V17.636h-1.905v12.488z" fill="white" />
    <path d="M10.435 7.538c-.322.34-.513.864-.513 1.544v21.847c0 .68.191 1.204.513 1.544l.08.079 12.236-12.236v-.289L10.515 7.791l-.08.087-.08-.34z" fill="url(#paint0_linear)" />
    <path d="M26.829 24.403l-4.077-4.087v-.29l4.077-4.086.092.053 4.83 2.745c1.38.783 1.38 2.065 0 2.857l-4.83 2.745-.092.063z" fill="url(#paint1_linear)" />
    <path d="M26.92 24.34l-4.168-4.168-12.318 12.318c.455.483 1.205.54 2.066.06l14.42-8.21z" fill="url(#paint2_linear)" />
    <path d="M26.92 15.972l-14.42-8.2c-.861-.49-1.611-.432-2.066.052l12.318 12.318 4.168-4.17z" fill="url(#paint3_linear)" />
    <defs>
      <linearGradient id="paint0_linear" x1="21.423" y1="8.716" x2="5.028" y2="25.111" gradientUnits="userSpaceOnUse">
        <stop stopColor="#00A0FF" />
        <stop offset="0.0066" stopColor="#00A1FF" />
        <stop offset="0.2601" stopColor="#00BEFF" />
        <stop offset="0.5122" stopColor="#00D2FF" />
        <stop offset="0.7604" stopColor="#00DFFF" />
        <stop offset="1" stopColor="#00E3FF" />
      </linearGradient>
      <linearGradient id="paint1_linear" x1="33.648" y1="20.172" x2="9.831" y2="20.172" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FFE000" />
        <stop offset="0.4087" stopColor="#FFBD00" />
        <stop offset="0.7754" stopColor="#FFA500" />
        <stop offset="1" stopColor="#FF9C00" />
      </linearGradient>
      <linearGradient id="paint2_linear" x1="24.404" y1="22.298" x2="2.071" y2="44.631" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FF3A44" />
        <stop offset="1" stopColor="#C31162" />
      </linearGradient>
      <linearGradient id="paint3_linear" x1="7.297" y1="0.176" x2="17.459" y2="10.338" gradientUnits="userSpaceOnUse">
        <stop stopColor="#32A071" />
        <stop offset="0.0685" stopColor="#2DA771" />
        <stop offset="0.4762" stopColor="#15CF74" />
        <stop offset="0.8009" stopColor="#06E775" />
        <stop offset="1" stopColor="#00F076" />
      </linearGradient>
    </defs>
  </svg>
);

const Footer = () => {
  const [logoUrl, setLogoUrl] = useState(() => {
    try {
      const cached = localStorage.getItem('bento_footer_data');
      return cached ? JSON.parse(cached).logoUrl : '';
    } catch { return ''; }
  });
  const [qrUrl, setQrUrl] = useState(() => {
    try {
      const cached = localStorage.getItem('bento_footer_data');
      return cached ? JSON.parse(cached).qrUrl : '';
    } catch { return ''; }
  });
  const [popularSearches, setPopularSearches] = useState(() => {
    try {
      const cached = localStorage.getItem('bento_footer_data');
      return cached ? JSON.parse(cached).popularSearches : [];
    } catch { return []; }
  });
  const [showServicesDropdown, setShowServicesDropdown] = useState(false);

  // Quick Links (removed Shop)
  const quickLinks = [
    { name: 'Home', href: '/' },
    { name: 'Blog', href: '/blog' },
    { name: 'Contact', href: '/contact' },
    { name: 'Bulk Order', href: '/bulk-order' },
  ];

  // Services submenu (non-clickable, just text)
  const services = ['Lunch', 'Dinner', 'Subscription'];

  // Help Center Links (removed Become an Affiliate, added Request Delete Account)
  const helpCenterLinks = [
    { name: 'Privacy Policy', href: '/privacypolicy' },
    { name: 'Shipping policy', href: '/DeliveryPolicy' },
    { name: 'Terms and conditions', href: '/termsandconditions' },
    { name: 'Refund and Returns Policy', href: '/RefundAndCancellation', multiline: true },
    { name: 'Request Delete Account', href: '/requestdeleteaccount' },
  ];


  useEffect(() => {
    const fetchFooterData = async () => {
      try {
        const footerRef = doc(db, 'home', 'footer');
        const footerSnap = await getDoc(footerRef);
        if (footerSnap.exists()) {
          const data = footerSnap.data();
          let newLogo = logoUrl;
          let newQr = qrUrl;
          let newPopular = popularSearches;

          if (data.logo1) {
            newLogo = data.logo1;
            setLogoUrl(newLogo);
          }
          if (data.Qr) {
            newQr = data.Qr;
            setQrUrl(newQr);
          }
          if (data.popularTexts) {
            newPopular = data.popularTexts.split(',').map(text => text.trim()).filter(text => text.length > 0);
            setPopularSearches(newPopular);
          }

          localStorage.setItem('bento_footer_data', JSON.stringify({
             logoUrl: newLogo,
             qrUrl: newQr,
             popularSearches: newPopular
          }));
        }
      } catch (error) {
        console.error("Error fetching Footer data:", error);
      }
    };

    fetchFooterData();
  }, []);


  return (
    <footer className="footer-container">
      {/* Locations Section - Single Location: Gurgaon */}
      <div className="footer-locations-section">
        <div className="footer-locations-list">
          <span className="footer-locations-title">Locations</span>
          <span className="footer-location-separator">|</span>
          <span className="footer-location-text">Gurgaon</span>
        </div>
      </div>

      {/* Main Footer Content - 4 Columns */}
      <div className="footer-main-content">
        {/* Column 1: Logo & Social */}
        <div className="footer-column">
          {/* Logo */}
          <div className="footer-logo-container">
            {logoUrl ? (
              <img
                src={logoUrl}
                alt="BentoBox Logo"
                title="BentoBox Logo"
                className="footer-logo"
              />
            ) : (
              <div className="footer-logo-placeholder">
                <span className="footer-logo-text">Bento<br />Box</span>
              </div>
            )}
          </div>

          {/* Tagline */}
          <p className="footer-tagline">
            Maa ke haath ka swaad, har din. Experience
            the warmth of home-cooked meals delivered
            fresh to your doorstep in Gurgaon.
          </p>

          {/* Social Icons - Added Pinterest & X, Removed YouTube */}
          <div className="footer-social-icons">
            <a href="https://www.instagram.com/getbentobox.in" className="footer-social-icon" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
              <InstagramIcon />
            </a>
            <a href="https://www.linkedin.com/company/getbentobox/" className="footer-social-icon" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
              <LinkedInIcon />
            </a>
            <a href="https://x.com/getbentobox_?s=21" className="footer-social-icon" aria-label="X (Twitter)" target="_blank" rel="noopener noreferrer">
              <XTwitterIcon />
            </a>
            <a href="https://wa.me/919876095163?text=Hi%20BentoBox!" className="footer-social-icon" aria-label="WhatsApp" target="_blank" rel="noopener noreferrer">
              <WhatsAppIcon />
            </a>
            <a href="https://pin.it/3RhWbSsgh" className="footer-social-icon" aria-label="Pinterest" target="_blank" rel="noopener noreferrer">
              <PinterestIcon />
            </a>
          </div>
        </div>

        {/* Column 2: Quick Links */}
        <div className="footer-column">
          <h3 className="footer-column-title">Quick link</h3>
          <ul className="footer-link-list">
            {quickLinks.map((link) => (
              <li key={link.name} className="footer-link-item">
                <a href={link.href} className="footer-link">{link.name}</a>
              </li>
            ))}
            {/* Services with dropdown - links are just text now */}
            <li className="footer-link-item">
              <button
                className={`footer-services-button ${showServicesDropdown ? 'open' : ''}`}
                onClick={() => setShowServicesDropdown(!showServicesDropdown)}
              >
                Services
                <ChevronDownIcon />
              </button>
              {showServicesDropdown && (
                <ul className="footer-dropdown-menu">
                  {services.map((service) => (
                    <li key={service} className="footer-dropdown-item">
                      <span className="footer-dropdown-text">{service}</span>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          </ul>
        </div>

        {/* Column 3: Help Center */}
        <div className="footer-column">
          <h3 className="footer-column-title">Help center</h3>
          <ul className="footer-link-list">
            {helpCenterLinks.map((link) => (
              <li key={link.name} className="footer-link-item">
                <a href={link.href} className="footer-link">
                  {link.multiline ? (
                    <>
                      Refund and Returns<br />Policy
                    </>
                  ) : link.name}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Column 4: Get In Touch */}
        <div className="footer-column">
          <h3 className="footer-column-title">Get In Touch</h3>

          {/* Email */}
          <div className="footer-contact-item">
            <MailIcon />
            <a href="mailto:support@getbentobox.in" className="footer-contact-link">support@getbentobox.in</a>
          </div>

          {/* Phone */}
          <div className="footer-contact-item">
            <WhatsappIcon />
            <a href="https://wa.me/919876095163?text=Hi%20BentoBox!" target="_blank" rel="noopener noreferrer" className="footer-contact-link">+91 9876095163</a>
          </div>

          {/* Map Embed - Gurgaon Location */}
          <div className="footer-map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d224356.91702968857!2d76.82493665!3d28.423015749999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d19d582e38859%3A0x2cf5fe8e5c64b1e!2sGurugram%2C%20Haryana!5e0!3m2!1sen!2sin!4v1706715600000!5m2!1sen!2sin"
              className="footer-map-iframe"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="BentoBox Location - Gurgaon"
            ></iframe>
          </div>
        </div>
      </div>

      {/* Popular Searches & App Download Row */}
      <div className="footer-bottom-row">
        {/* Popular Searches - Left Side */}
        <div className="footer-popular-searches-section">
          <h3 className="footer-popular-searches-title">Popular Searches</h3>
          <p className="footer-popular-searches-list">
            {popularSearches.map((search, index) => (
              <React.Fragment key={search}>
                <span className="footer-popular-search-text">{search}</span>
                {index < popularSearches.length - 1 && ' | '}
              </React.Fragment>
            ))}
          </p>
        </div>

        {/* App Download Section - Right Side */}
        <div className="footer-app-download-section">
          <div className="footer-app-badges">
            <a
              href="https://apps.apple.com/in/app/bentobox-home-cooked-meals/id6749816927"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-app-badge-link"
            >
              <AppStoreBadge className="footer-app-badge" />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.home_meals_1&hl=en_IN"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-app-badge-link"
            >
              <GooglePlayBadge className="footer-app-badge" />
            </a>
          </div>

          {/* QR Code from Firestore */}
          {qrUrl && (
            <div className="footer-qr-container">
              <div className="footer-qr-wrapper">
                <img
                  src={qrUrl}
                  alt="QR Code to Download BentoBox App"
                  title="Scan to Download BentoBox App"
                  className="footer-qr-image"
                />
              </div>
              <p className="footer-qr-text">Scan to download</p>
            </div>
          )}
        </div>
      </div>

      {/* Copyright Section */}
      <div className="footer-copyright-section">
        <p className="footer-copyright-text">
          © Copyright 2026, All Rights Reserved By BentoBox
        </p>
      </div>
    </footer>
  );
};

export default Footer;
